import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,Box,MiniMinusButton,Select} from '../components/Input';
import u from '../utilities/Utilities';
import {ELearning,fileImageReference} from '../data/Mimetypes';
import moment from 'moment';

export default class CourseList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"E-Learning Courses",
        permission:"course",          //Accepts combined permission module as well
        //combinedField:"",   //Used when permission exists in a combined field
        url:"/course-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-course-entries",
        deleteURL:"/api/delete-course-entries",
        spreadsheetURL:"/api/generate-course-spreadsheet",
        overviewURL:"/api/get-all-course-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"course-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        quizOptions:[],
    };

    componentDidMount=()=>{
        this.getQuizOptions();
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onCloneEntry=(content)=>{
        let clone=JSON.parse(JSON.stringify(content));
        let entryData={
            reference:clone.reference,
            material:clone.material,
        };
        this.r['pageMenu'].toggleForm("add",true);
        this.r['pageMenu'].getRef("add").editEntry(clone,entryData);
    }

    getQuizOptions=()=>{
        u.post({
            url:"/api/get-quiz-options",
            data:{},
            success:(quizOptions)=>{
                this.setState({quizOptions:quizOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index} 
                                          index={index} 
                                          content={content} 
                                          onChange={onChange} 
                                          onContentChange={onContentChange} 
                                          registerReference={registerRef} 
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          onCloneEntry={this.onCloneEntry}
                                          quizOptions={this.state.quizOptions}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    r={};

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    onAttachQuiz=async ()=>{
        const keys=['quizID'];
        let data = {};
        for(var i=0; i<keys.length; i++){
            const current=this.r[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data[keys[i]]=current.value;
        }
        this.setState({loading:true,loadText:"Updating..."});
        try{
            const {content}=this.props;
            const response = await u.postAsync({
                url:"/api/course-attach-quiz",
                data:{
                    ...data,
                    courseID:content.courseID
                }
            });
            for(var key in response.data){
                this.props.onChange(response.data[key],key,this.props.index);
            }
            this.setState({loading:false,step:"view",error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({loading:false,error:error});
        }
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel} 
                                    permission={settings.permission} 
                                    content={content} 
                                    onChange={this.props.onChange} 
                                    index={this.props.index}
                                    />

                    <div style={{margin:"30px auto",maxHeight:"none"}} className="list-table">
                        <table>
                            <thead>
                                <tr>
                                    <th className='remove left'/>
                                    <th style={{width:"180px"}}>Language</th>
                                    <th>Course Title</th>
                                    <th style={{width:"180px"}} className='right'>Material</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    content.material.map((item,index)=>{
                                        return(
                                            <tr key={index} className='item'>
                                                <td>{index+1}.</td>
                                                <td>{(index==0) ? "(Default) " : ""}{item.language}</td>
                                                <td>{item.label}</td>
                                                <td>
                                                    {
                                                        (item.materialType)
                                                            ?
                                                            <TextButton style={{margin:"0"}} onClick={()=>{window.open(item.filestamp,"__blank")}}>{item.materialType}</TextButton>
                                                            :
                                                            "Default"
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>

                    {
                        (canEdit)
                            ?
                            <div style={{margin:"20px auto"}}>
                                <Button onClick={()=>{this.props.onCloneEntry(content)}}>Clone Entry</Button>
                            </div>
                            :
                            null
                    }

                    {
                        (canEdit)
                            ?
                            <div style={{margin:"20px auto"}}>
                                <TextButton onClick={()=>{this.setState({step:"quiz",error:""})}}>Attach/Replace Quiz</TextButton>
                            </div>
                            :
                            null
                    }
                </Step>

                <Step active={this.state.step=="quiz"}>
                    <div style={{position:"relative",fontSize:"14px"}}>
                        <h3>Select Quiz to Attach/Replace</h3>
                        <div className='segment-full-item'>
                            <div className='segment-item-input'>
                                <Select ref={(ref)=>{this.r['quizID']=ref}}
                                        label="Quiz"
                                        values={{options:this.props.quizOptions}}
                                        />
                            </div>
                        </div>
                        <div style={{margin:"20px auto"}}>
                            Note. Replaced quiz will no longer be visible to targets
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onAttachQuiz}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{
    
    settings={
        addType:0,
        addURL:"/api/create-course-entry",
    };

    defaultMaterial=[];

    r={};

    state={
        step:"add",
        entryData:{
            material:[],
        },
        options:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({
                error:"",
                entryData:{
                    material:this.defaultMaterial.slice(0),
                }
            });
        }
    }

    componentDidMount=()=>{
        this.getOptions();
        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "eLearningLanguage"
                    ]
                }
            });
            let entryData=this.state.entryData;
            const defaultMaterial = response.data.eLearningLanguage.map((item)=>{
                return {language:item.value,label:""};
            });
            entryData.material = defaultMaterial.slice(0);
            this.defaultMaterial = defaultMaterial;
            this.setState({
                options:response.data,
                entryData:entryData,
            });
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        this.setState({error:""});
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        for(var i=0; i<entryData.material.length; i++){
            const current=this.r['label-'+i].validate();

            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }

            if((!u.notNull(entryData.material[i].url) && !u.notNull(entryData.material[i].filestamp)) && i==0){
                this.setState({error:"Please select material file for at least the default language"});
                return 0;
            }
        }

        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        let entryData={};
        entryData.material=this.state.options.eLearningLanguage.map((item)=>{
            return {language:item.value,label:""};
        });

        this.setState({
            entryData:entryData,
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onUploadRequest=(index)=>{
        this.fileIndex=index;
        this.setState({step:"add-attachment",error:""});
    }

    onFileAdded=(filename,file,ext,filedetails)=>{
        //console.log(filedetails);
        this.nextFile = {
            filename:filename,
            materialType:filedetails.materialType,
        };
        this.setState({loading:true,loadText:"Uploading..."});
    }

    onAddAttachment=(url)=>{
        let entryData=this.state.entryData;
        entryData.material[this.fileIndex]= {
            ...entryData.material[this.fileIndex],
            filename:this.nextFile.filename,
            url:url,
            materialType:this.nextFile.materialType
        };
        this.setState({entryData:entryData,step:"add",error:"",loading:false});
    }

    onRemoveAttachment=(index)=>{
       let entryData=this.state.entryData;
       entryData.material.splice(index,1);
       this.setState({entryData:entryData});
    }

    onBulkUpload=()=>{
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onBulkUpload()
    }

    onChangeMaterial=(value,field,index)=>{
        let {entryData}=this.state;
        entryData.material[index][field]=value;
        this.setState({entryData:entryData});
    }

    editEntry=(entryData)=>{
        //Merge material column with new material
        const newMaterial = this.defaultMaterial.slice(0).map((item)=>{
            const existingMaterialArr = entryData.material.filter((existing)=>{
                return existing.language == item.language;
            });
            if(existingMaterialArr.length > 0){
                return existingMaterialArr[0];
            }
            return item;
        });
        entryData.material = newMaterial;
        this.setState({entryData:entryData});
    }

    render=()=>{
        const {loading,loadText,step,options,entryData}=this.state;

        const fields=[
            {dataType:"box",label:"Course Reference",field:"reference",rules:{required:true}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        
                        <div className='list-table' style={{position:"relative",fontSize:"12px",maxHeight:"none"}}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className='remove left'/>
                                        <th style={{width:"180px"}} >Language</th>
                                        <th>Course Title</th>
                                        <th style={{width:"180px"}}>Material</th>
                                        <th style={{width:"100px"}} className='right'>Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        entryData.material.map(
                                            (item,index,arr)=>{
                                                return (
                                                    <tr key={index}>
                                                        <td>{index+1}.</td>
                                                        <td>{index==0 ? "(Default) " : ""}{item.language}</td>
                                                        <td>
                                                            <Box ref={(ref)=>{this.r['label-'+index]=ref}}
                                                                 label={item.language + " Course Title"}
                                                                 values={{value:item.label}}
                                                                 rules={{required:(index==0),placeholder:(index==0) ? undefined : "Optional"}}
                                                                 field="label"
                                                                 index={index}
                                                                 onChange={this.onChangeMaterial}
                                                                 />
                                                        </td>
                                                        <td>
                                                            <TextButton style={{margin:0}} onClick={()=>{this.onUploadRequest(index)}}>{(item.filename) ? item.filename : "Choose File"}</TextButton>
                                                        </td>
                                                        <td>{(item.materialType) ? item.materialType : "None"}</td>
                                                    </tr>
                                                )
                                            }
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div style={{margin:"20px auto"}} className='segment-note'> 
                            Note. If title/material are left empty, the default language will be used
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="add-attachment"}>
                        <Dropzone label={"Photo"}
                                  accessibleForPreview={true}
                                  onAdded={this.onFileAdded}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={ELearning}
                                  />
                        
                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"add",error:""})}}>Back</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}